export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Left: Brand */}
          <div className="md:col-span-4">
            <h3 className="font-heading text-3xl md:text-4xl font-bold mb-4">ALLCHINABUY</h3>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-xs mb-6">
              The smartest China product sourcing spreadsheet system for dropshippers, resellers, and online entrepreneurs.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-twitter-x-line', label: 'Twitter' },
                { icon: 'ri-instagram-line', label: 'Instagram' },
                { icon: 'ri-tiktok-line', label: 'TikTok' },
                { icon: 'ri-youtube-line', label: 'YouTube' },
              ].map((social) => (
                <a
                  key={social.label}
                  href="#"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors duration-300 cursor-pointer"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Center: Contact */}
          <div className="md:col-span-3 md:col-start-6">
            <div className="space-y-5">
              <div>
                <p className="text-xs uppercase tracking-widest text-foreground-500 mb-1 font-medium">Address</p>
                <p className="text-foreground-300 text-sm">Guangzhou, China</p>
              </div>
              <div>
                <p className="text-xs uppercase tracking-widest text-foreground-500 mb-1 font-medium">Phone</p>
                <p className="text-foreground-300 text-sm">+86 20 8888 6666</p>
              </div>
              <div>
                <p className="text-xs uppercase tracking-widest text-foreground-500 mb-1 font-medium">Email</p>
                <p className="text-foreground-300 text-sm">hello@allchinabuy.watch</p>
              </div>
            </div>
          </div>

          {/* Right: Quick Links */}
          <div className="md:col-span-3">
            <div className="space-y-5">
              <div>
                <p className="text-xs uppercase tracking-widest text-foreground-500 mb-3 font-medium">Quick Links</p>
                <div className="flex flex-col gap-2">
                  <a href="#features" className="text-foreground-300 text-sm hover:text-background-50 transition-colors duration-300 whitespace-nowrap">Features</a>
                  <a href="#comparison" className="text-foreground-300 text-sm hover:text-background-50 transition-colors duration-300 whitespace-nowrap">Comparison</a>
                  <a href="#categories" className="text-foreground-300 text-sm hover:text-background-50 transition-colors duration-300 whitespace-nowrap">Categories</a>
                  <a href="#articles" className="text-foreground-300 text-sm hover:text-background-50 transition-colors duration-300 whitespace-nowrap">Blog</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-foreground-800/60">
        <div className="w-full px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} AllChinaBuy. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors duration-300 whitespace-nowrap">Privacy</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors duration-300 whitespace-nowrap">Terms</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors duration-300 whitespace-nowrap">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}